// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  padding-top: 56px;
}

.hero-inner {
  display: flex;
  align-items: center;
  gap: 48px;
  flex-wrap: wrap;
}

/* The copy takes the larger share of the row so each heading line fits on
   one line beside the art. */
.hero-copy {
  flex: 1.6 1 520px;
}

/* Same extra-bold Poppins as the interior page headers, in olive on the page. */
.hero-copy h1 {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: clamp(1.85rem, 4.2vw, 3.25rem) !important;
  line-height: 1.1;
  color: var(--color-olive);
  margin-bottom: 18px;
}

/* Coral-deep on the page is 5.24, AA for this size. */
.hero-copy h2 {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--text-accent);
  margin-bottom: 20px;
}

.hero-copy p {
  font-size: 1rem;
  max-width: 520px;
  margin-bottom: 12px;
  &.last-line {
    margin-bottom: 28px;
  }
}

.hero-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.hero-line {
  display: block;
}

/* Keep each heading line whole once there's room; narrower screens wrap. */
@media (min-width: 900px) {
  .hero-line,
  .hero-copy h2 {
    white-space: nowrap;
  }
}

.hero-art {
  flex: 1 1 300px;
  display: flex;
  justify-content: center;
}

.hero-art img {
  max-width: 100%;
  border-radius: var(--radius-lg);
}

.funding-grid,
.support-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
}

.funding-card {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  padding: 28px;
  box-shadow: var(--shadow-soft);
}

.support-item {
  background-color: var(--surface-sunken);
  border-radius: var(--radius-md);
  padding: 28px;
}

/* Fixed-height logo row in both cards, so the email lines below line up. */
.partner-logos {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  min-height: 100px;
  margin: 16px 0;
}

/* White chip so logos with white backgrounds don't sit as boxes on the sunken card. */
.partner-logo {
  display: block;
  height: 64px;
  max-width: 100%;
  object-fit: contain;
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  padding: 10px 14px;
  box-sizing: border-box;
  transition: transform 0.15s ease;
}

/* Same hover lift as the Busy Bees logo. */
.partner-logos a:hover .partner-logo {
  transform: translateY(-2px);
}

/* The Busy Bees logo is a sticker with its own white border, so no chip. */
.volunteer-logo-link {
  display: block;
  border-radius: var(--radius-md);
}

.volunteer-logo {
  display: block;
  height: 100px;
  width: auto;
  max-width: 100%;
  transition: transform 0.15s ease;
}

.volunteer-logo-link:hover .volunteer-logo {
  transform: translateY(-2px);
}

.eyebrow {
  display: inline-block;
  margin-bottom: 8px;
  color: var(--text-accent);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.btn {
  margin: 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Landing.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;6BAC6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,gCAAgC;EAChC,gBAAgB;EAChB,oDAAoD;EACpD,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;AACf;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sFAAsF;AACtF;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;AAC7B;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".hero {\n  padding-top: 56px;\n}\n\n.hero-inner {\n  display: flex;\n  align-items: center;\n  gap: 48px;\n  flex-wrap: wrap;\n}\n\n/* The copy takes the larger share of the row so each heading line fits on\n   one line beside the art. */\n.hero-copy {\n  flex: 1.6 1 520px;\n}\n\n/* Same extra-bold Poppins as the interior page headers, in olive on the page. */\n.hero-copy h1 {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: clamp(1.85rem, 4.2vw, 3.25rem) !important;\n  line-height: 1.1;\n  color: var(--color-olive);\n  margin-bottom: 18px;\n}\n\n/* Coral-deep on the page is 5.24, AA for this size. */\n.hero-copy h2 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: var(--text-accent);\n  margin-bottom: 20px;\n}\n\n.hero-copy p {\n  font-size: 1rem;\n  max-width: 520px;\n  margin-bottom: 12px;\n  &.last-line {\n    margin-bottom: 28px;\n  }\n}\n\n.hero-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.hero-line {\n  display: block;\n}\n\n/* Keep each heading line whole once there's room; narrower screens wrap. */\n@media (min-width: 900px) {\n  .hero-line,\n  .hero-copy h2 {\n    white-space: nowrap;\n  }\n}\n\n.hero-art {\n  flex: 1 1 300px;\n  display: flex;\n  justify-content: center;\n}\n\n.hero-art img {\n  max-width: 100%;\n  border-radius: var(--radius-lg);\n}\n\n.funding-grid,\n.support-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 24px;\n}\n\n.funding-card {\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  padding: 28px;\n  box-shadow: var(--shadow-soft);\n}\n\n.support-item {\n  background-color: var(--surface-sunken);\n  border-radius: var(--radius-md);\n  padding: 28px;\n}\n\n/* Fixed-height logo row in both cards, so the email lines below line up. */\n.partner-logos {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  min-height: 100px;\n  margin: 16px 0;\n}\n\n/* White chip so logos with white backgrounds don't sit as boxes on the sunken card. */\n.partner-logo {\n  display: block;\n  height: 64px;\n  max-width: 100%;\n  object-fit: contain;\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  padding: 10px 14px;\n  box-sizing: border-box;\n  transition: transform 0.15s ease;\n}\n\n/* Same hover lift as the Busy Bees logo. */\n.partner-logos a:hover .partner-logo {\n  transform: translateY(-2px);\n}\n\n/* The Busy Bees logo is a sticker with its own white border, so no chip. */\n.volunteer-logo-link {\n  display: block;\n  border-radius: var(--radius-md);\n}\n\n.volunteer-logo {\n  display: block;\n  height: 100px;\n  width: auto;\n  max-width: 100%;\n  transition: transform 0.15s ease;\n}\n\n.volunteer-logo-link:hover .volunteer-logo {\n  transform: translateY(-2px);\n}\n\n.eyebrow {\n  display: inline-block;\n  margin-bottom: 8px;\n  color: var(--text-accent);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.btn {\n  margin: 2px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
